export enum CpwResolutionType {
    ACCEPT_INTO_INVENTORY = 'accept-into-inventory',
    CREATE_RTV = 'create-rtv',
    DISPOSAL = 'disposal',
    QUARANTINE = 'quarantine',
    TRANSFER = 'transfer',
}
